import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
	root: {
		border: '1px solid rgba(0,0,0,0.12)',
		borderRadius: '4px',
		fontWeight: 'normal',
		minWidth: '100px',
		[theme.breakpoints.up('sm')]: {
			minWidth: '130px',
		},
  '&:hover': {
      backgroundColor: '#F0F5F8',
    },
    // '&$disabled': {
		// 	border: '1px solid rgba(0,0,0,0.12)',
		// 	color: 'rgba(0,0,0,0.38)'
    // },
	}
});

const CustomOutlinedButton = withStyles(styles)(Button);

export default CustomOutlinedButton;



// WEBPACK FOOTER //
// ./src/js/components/Mui/CustomOutlinedButton.js